import { useParams } from "@tanstack/react-router";
import { RecordsPage } from "../features/records/RecordsPage";

export function RecordsRoute() {
  const { recordId } = useParams({ strict: false });
  return <RecordsPage routeRecordId={recordId} />;
}
